(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("informed", [], factory);
	else if(typeof exports === 'object')
		exports["informed"] = factory();
	else
		root["informed"] = factory();
})(this, function() {
return 